export const MODULE_VISIBILITY: Record<'sports' | 'rides', boolean> = {
  sports: false,
  rides: false,
};

export const EDUCATION_FOCUS_REDIRECT = '/education';

export const isSportsModuleEnabled = MODULE_VISIBILITY.sports;
export const isRidesModuleEnabled = MODULE_VISIBILITY.rides;
